import React, { Component, Fragment } from 'react';
import { Menu, X } from 'react-feather';

import classnames from "classnames";
import { formatUnreadMessageCount } from '../../helpers/ChatUtils';

class MobileMenuToggle extends Component {

  toggleMenuVisibility = () => {
    const { mobileMenuOpened, toggleMobileMenu } = this.props;
    toggleMobileMenu(!mobileMenuOpened);
  };

  renderCloseButton = () => <X size={24} />

  renderOpenButton = (unreadMessageCount, mentioned) => (
    <Fragment>
      <Menu size={24} />
      {unreadMessageCount > 0 && <span id="mobile-notification-count"
        className={classnames({
          "mentioned": mentioned
      })}>
        {formatUnreadMessageCount(unreadMessageCount)}
      </span>}
    </Fragment>
  )

  render() {
    const { mobileMenuOpened, unreadMessageCount, mentioned, showLabel, fullWidth } = this.props;
    return (
      <button
        className={classnames({
          "mobile-menu-icon": true,
          "full-width": fullWidth
        })}
        onClick={this.toggleMenuVisibility}
        name="menuIcon"
      >

        {mobileMenuOpened
          ? this.renderCloseButton()
          : (
            <Fragment>
              {this.renderOpenButton(unreadMessageCount, mentioned)}
              {showLabel && <label htmlFor="menuIcon">Menu</label>}
            </Fragment>
          )}

      </button>
    )
  }
};

export default MobileMenuToggle;
